import cookie from 'cookie';

// Contexts
import { getConfigProperty } from '../../EnvironmentConfig/EnvironmentConfig';
// Constants
import {
    GOOGLE_ANALYTICS_CONFIG,
    GOOGLE_ANALYTICS_CONFIG_URL,
    GOOGLE_ANALYTICS_HEADER_CONFIG_URL,
    GOOGLE_ANALYTICS_NON_PRODUCTION_CONFIG,
    SSO_CDH_COMPANY_KEY,
} from '../Constants/Constants';

export const LoadGoogleAnalyticsScript = (type: string) => {
    const ssoReferringCompany: string = cookie.parse(document.cookie)[SSO_CDH_COMPANY_KEY];
    const referringCompany: string = ssoReferringCompany ?? cookie.parse(document.cookie).cdhCompany;

    let currentGoogleAnalyticsConfig: string = '';
    let googleAnalyticsScript: string = '';

    if(referringCompany) {
        const currentEnv = getConfigProperty('appEnvironment');
        currentGoogleAnalyticsConfig = GOOGLE_ANALYTICS_CONFIG[referringCompany];

        googleAnalyticsScript = type === 'header' ? GOOGLE_ANALYTICS_HEADER_CONFIG_URL : type === 'body' ? GOOGLE_ANALYTICS_CONFIG_URL : '';

        if(googleAnalyticsScript.length > 0 && currentGoogleAnalyticsConfig && (currentEnv === 'production' || currentEnv === 'prod')) {
            googleAnalyticsScript = googleAnalyticsScript.replace(GOOGLE_ANALYTICS_NON_PRODUCTION_CONFIG,currentGoogleAnalyticsConfig);
        }
    }

    return googleAnalyticsScript;
};
